export default __webpack_public_path__ + "static/media/sandcrab1.2c3f0ada.jpeg";